var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 10.5C20.7998 10.5 21.5833 11.2835 21.5833 12.25V19.25C21.5833 20.2165 20.7998 21 19.8333 21H8.45825C7.00851 21 5.83325 19.8248 5.83325 18.375V9.625C5.83325 8.17526 7.00851 7 8.45825 7H18.0833C19.0498 7 19.8333 7.7835 19.8333 8.75V10.5ZM19.8333 10.5H9.33325M18.0833 15.75H17.2083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.88f6c056f89bcdb393049a3a3b8e6730.svg";
export { ForwardRef as ReactComponent };